<template>
   <section id="contact-section">
    <div class="row">
      <div class="col-md-12" >
          <iframe  style="    border: 0px;    width: 100%!important;height: 360px;" class="google-maps" :src="data.google_url" frameborder="0"  allowfullscreen></iframe>
      </div>
    </div>
        <div class="contact-info-box">
        <div class="container">
          <div class="title-section">
            <h1>{{data.title}}</h1>
            <span></span>
            <p>{{data.subtitle}}</p>
          </div>
          <div class="contact-box">
            <div class="row">

              <div class="col-md-6">  
                <form id="contact-form" action="/assets/contact.php" method="post">
                  <h2>{{data.form.title}}</h2>
                  <input name="name" required id="name" type="text" :placeholder="data.form.name_ph">
                  <input name="mail" required id="mail" type="text" :placeholder="data.form.email_ph">
                  <input name="website" id="website" type="text" :placeholder="data.form.website_ph">
                  <textarea name="comment" id="comment" :placeholder="data.form.message_ph"></textarea>
                  <button type="submit" name="contact-submit" id="submit_contact">
                  {{  data.form.buttom_title}}
                  </button>
                  <div id="msg" class="message"></div>
                </form>
              </div>

              <div class="col-md-6">
                <div class="contact-info">
                  <h2>{{data.info.title}}</h2>
                  <p>{{data.info.subtitle}}</p>
                  <ul class="contact-list">
                    <li>
                      <span><i class="fa fa-map-marker"></i></span>
                      <p>{{data.info.direction}}</p>
                    </li>
                    <li>
                      <span><i class="fa fa-phone"></i></span>
                      <p>{{data.info.phone}}</p>
                    </li>
                    <li>
                      <span><i class="fa fa-envelope-o"></i></span>
                      <p>{{data.info.email}}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </section>
</template>

<script>
export default {
  name: 'Contact',
  props: {
    data: Object
  },
  mounted:function(){

        var form = $('#contact-form');
    var message = $('#msg');
   var submitContact = $('#submit_contact');
   $(form).submit(function(e) {
    e.preventDefault();

    var $this = $(this);
    
    $.ajax({
      type: "POST",
      url: 'assets/contact.php',
      dataType: 'json',
      cache: false,
      data: form.serialize(),
      success: function(data) {

        if(data.info !== 'error'){
          $this.parents('form').find('input[type=text],textarea,select').filter(':visible').val('');
          message.hide().removeClass('alert-success').removeClass('alert-danger').addClass('alert-success').html(data.msg).fadeIn('slow').delay(5000).fadeOut('slow');
        } else {
          message.hide().removeClass('alert-success').removeClass('alert-danger').addClass('alert-danger').html(data.msg).fadeIn('slow').delay(5000).fadeOut('slow');
        }
      }
    });
  });
  
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
